import { render, staticRenderFns } from "./Viral.vue?vue&type=template&id=462148ee&scoped=true"
import script from "./Viral.vue?vue&type=script&lang=js"
export * from "./Viral.vue?vue&type=script&lang=js"
import style0 from "./Viral.vue?vue&type=style&index=0&id=462148ee&prod&scoped=true&lang=css"
import style1 from "./Viral.vue?vue&type=style&index=1&id=462148ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462148ee",
  null
  
)

export default component.exports